import PurchaseOrdersManagement from "./components/purchaseOrderManagement";
import PurchaseRequestsManagement from "./components/purchase_requests";
import AddPurchaseRequests from "./components/add_purchase_requests";
import SupplierManagement from "./components/suppliers";
import QuotationsManagement from "./components/quotations";
import AddSupplier from "./components/add_supplier";
import AddQuotationRequest from "./components/add_quotation_request";
import AddPurchaseOrders from "./components/add_purchase_order";
import Settings from "./components/settingsManagement";
import ApprovalWorkflow from "./components/approval_workflows";
import ViewSupplier from "./components/view_supplier";
import AddRFQResponse from "../supplier_rfq_management/tabs/add_rfq_response";
import RFQResponses from  "./components/rfq_responses";
import ViewPurchaseRequest from  "./components/view_purchase_request";
import EditPurchaseRequest from "./components/edit_purchase_request";
import ViewPurchaseOrder from "./components/view_purchase_order";
import EditPurchaseOrder from "./components/edit_purchase_order";


const procurementRoutes = [
  {
    path: "/facility/procurement_management/purchase_orders",
    element: <PurchaseOrdersManagement />,
  },
  {
    path: "/facility/procurement_management/purchase_requests",
    element: <PurchaseRequestsManagement />,
  },
  {
    path: "/facility/procurement_management/purchase_requests/add",
    element: <AddPurchaseRequests />,
  },
  {
    path: "/facility/procurement_management/supplier_management",
    element: <SupplierManagement />,
  },
  {
    path: "/facility/procurement_management/quotations_management",
    element: <QuotationsManagement />,
  },
  {
    path: "/facility/procurement_management/supplier/add",
    element: <AddSupplier />,
  },
  {
    path: "/facility/procurement_management/quotations/add",
    element: <AddQuotationRequest />,
  },
  {
    path: "/facility/procurement_management/purchase_orders/add",
    element: <AddPurchaseOrders />,
  },
  {
    path: "/facility/procurement_management/settings",
    element: <Settings />,
  },
  {
    path: "/facility/procurement_management/approval_workflows",
    element: <ApprovalWorkflow />,
  },
  {
    path: "/facility/procurement_management/supplier/view/:supplierId",
    element: <ViewSupplier />,
  },
  {
    path: "/facility/procurement_management/purchase_requests/view/:requestId",
    element: <ViewPurchaseRequest />,
  },
  {
    path: "/facility/procurement_management/purchase_order/view/:orderId",
    element: <ViewPurchaseOrder/>,
  },
  {
    path: "/facility/procurement_management/purchase_order/edit/:orderId",
    element: <EditPurchaseOrder/>,
  },
  {
    path: "/facility/procurement_management/purchase_requests/edit/:requestId",
    element: <EditPurchaseRequest />,
  },
  {
    path: "/facility/supplier_rfq_management/tabs/add_rfq_response/:rfqId",
    element: <AddRFQResponse />,
  },
  {
    path: "/facility/procurement_management/quotations/responses/:rfqId",
    element: <RFQResponses />,
  },
];

export default procurementRoutes;